<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >  
                <template v-slot:header >
                  <div class="header-card">
                    Documentos del Afiliado
                  </div> 
                </template>              
                <b-nav tabs >
                  <b-nav-item :active="active===0" @click="active=0">Cargar Documentos</b-nav-item>
                  <b-nav-item :active="active===1" @click="active=1;searchDocumentos(1)"  class="d-none d-md-block">Historial de documentos</b-nav-item>
                </b-nav> 
                <div  style="border:1px solid; border-top:none;border-color: #dee2e6 ">
                  <div v-if="active===0">                    
                    <validation-observer v-slot="{ invalid } ">    
                      <b-row align-v="center"> 
                        <sw-searchs
                          :md="5"
                          :lg="5"
                          style="margin-top:20px"
                          label='Seleccionar afiliado'
                          list='datos_afiliado'
                          filterCampos="documento"
                          @input="inputSearchs"
                          >
                        </sw-searchs>  
                        <b-col class="d-none">
                          <b-button @click="searchSw.value='';resetDataForm()" style="margin-top:30px" size="sm">Limpiar</b-button>
                        </b-col>
                      </b-row> 
                      <b-row v-if="searchSw.value!=''">                               
                        <sw-inputs
                          inputTabla="afiliado_documentos"
                          inputCampo="name"></sw-inputs>  
                        <sw-inputs
                          v-if="uploadReady"
                          inputTabla="afiliado_documentos"
                          inputCampo="archivo"
                          :md="6" :lg="6"></sw-inputs>
                      </b-row>
                      <b-row v-if="searchSw.value!=''">
                        <b-col class="card-footer d-none  d-md-block">
                        <sw-saveform
                          :invalid="invalid"
                          :actualizar="dataIndex[namePath]!==false"
                          :index="dataIndex[namePath]"
                          nameBtn="Documento"
                          @save="saveForm">
                          </sw-saveform> 
                        </b-col>
                        <b-col class="card-footer d-md-none" >
                        <sw-saveform
                           limpiar
                          :invalid="invalid"
                          :actualizar="dataIndex[namePath]!==false"
                          :index="dataIndex[namePath]"
                          nameBtn=""
                          @save="saveForm"
                          @limpiar="searchSw.value='';resetDataForm()">
                          </sw-saveform> 
                        </b-col>
                      </b-row>                     
                    </validation-observer>                        
                  </div>
                  <div  v-if="active===1" style="padding:20px">
                    <sw-tableget
                      :tableItems="tableGBItems"
                      :tableSearch="tableGBSearch"
                      :tableOptions="tableGBoptions"
                      name="tableGet2"
                      route="get_afldocumentos"
                      :dataRoute="{others: []}"
                      @filtrar="getFiltrar"
                      @limpiar="getLimpiar"
                      @save="saveForm"
                      >     
                      <template v-slot:filtrar>
                        <b-row  style="margin-bottom:5px;padding-top:15px;border: 1px ridge;background: #fafafa">
                         <b-col :cols="4"> 
                           <b-form-group
                              class="mb-0"
                              label="Seleccionar Afiliado"
                            >                         
                              <c-multiselect
                                style="margin-bottom:15px"   
                                v-model="filter.id_datos_afiliado"                   
                                :options="lists.datos_afiliado"
                                label="name"
                                track-by="name"
                                :clear-on-select="false"
                                :preselect-first="false"
                                :searchable="true"
                                :customLabel="function (value) { return value.documento+' - '+value.name}"
                                :filterCampos="'id|name|documento'"
                                placeholder="Seleccionar"
                                >
                                </c-multiselect>  
                            </b-form-group>                                          
                          </b-col>
                        </b-row>                      
                      </template>   
                    </sw-tableget>
                  </div>
                </div>  
            </b-card> 
            <!--<b-card  style="margin-top: 30px"  v-if="dataPost[namePath].data.length>0 && active===0">
                <template v-slot:header >
                  <div class="header-card text-left">
                    Documentos Agrupados
                  </div> 
                </template> 
              <b-row>
                      <b-col>
                        <sw-tablepost
                            :tableOptions="['delete']"
                            :tableItems="[
                              {th: 'Titular', td: ['datos_afiliado/name']},
                              {th: 'Nombre', td: ['afiliado_documentos/name']},
                              {th: 'Archivos', td: ['subir_archivos'], archivo: true},
                            ]"
                            :tableView="['Titular','Nombre','Archivo']"
                            @save="saveForm"
                            >
                          </sw-tablepost> 
                      </b-col>
                    </b-row>
            </b-card> -->
      </b-col>      
    </b-row>      
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="lg"  
      >        
        <sw-modalafiliacion 
          v-if="openModal.modal.modal==='Afiliacion'"
          @save="saveForm"                     
          >
        </sw-modalafiliacion>     
    </b-modal>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwModalafiliacion  from '@/components/modals/afiliacion.vue'
import SwTablemultiple from '@/components/dataTable/tableMultiple.vue'
import SwTablepost from '@/components/dataTable/tablePost.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import Multiselect  from '@/components/vue-multiselect/src/'
import { ValidationObserver } from 'vee-validate'

export default {
  name: "afiliacion_servicios",
  components: { 
    SwSearchs,
    SwTablemultiple,
    SwSaveform,
    SwModalafiliacion,
    'c-multiselect': Multiselect,
    SwTablepost,
    SwInputs,
    SwTableget,
    ValidationObserver
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
